import React from 'react';
import { Card, Column, Row } from './styled/CallEndMessageStyled';
import Icon from '../Icon';

interface LocalizationLike {
    getText: (key: string) => string;
}

function CallEndMessage(props: { localization: LocalizationLike }) {
    const { localization } = props;
    const topMessage = localization.getText('trainer.call_messages.call_end.top');

    return (
        <Card className="message">
            <Column $marginRight={15}>
                <Icon name="CallEnded" />
            </Column>
            <Column>
                <Row>
                    <strong>{topMessage}</strong>
                </Row>
            </Column>
        </Card>
    );
}

export default CallEndMessage;
